import { render, staticRenderFns } from "./ModulePrivilegeEdit.vue?vue&type=template&id=bd0f3d5e&"
import script from "./ModulePrivilegeEdit.vue?vue&type=script&lang=js&"
export * from "./ModulePrivilegeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports